/*
  Group endpoints by resource and HTTP Method
*/

const warehouse = {
  get: () => `/warehouses`,
  getAll: () => `/all-warehouses`,
  getFulfilWarehouses: () => `/warehouse`,
  getOperators: () => `/warehouse/operators`,
  patch: ({ warehouseId }) => `/warehouse/${warehouseId}`,
  delete: ({ warehouseId }) => `/warehouse/${warehouseId}`,
  getById: ({ warehouseId }) => `/warehouse/${warehouseId}`,
  post: () => `/warehouse`,
  postInvitations: ({ warehouseId }) =>
    `/warehouses/${warehouseId}/invitations`,
  getPostageServiceVariants: () => `/warehouses/postage-service-variants`,
  getPostageServiceVariantsByCourierIdAndZoneId: ({ courierId, zoneId }) =>
    `/warehouses/postage-service-variants/${courierId}/${zoneId}`,
  getOperatorTypes: () => `/warehouses/operator-types`,
  postOperators: () => `/warehouses/operator`,
  patchWarehouseOperator: ({ warehouseOperatorId }) =>
    `/warehouses/operator/${warehouseOperatorId}`,
  deleteWarehouseOperator: ({ warehouseOperatorId }) =>
    `/warehouses/operator/${warehouseOperatorId}`,
  getWarehouseClients: () => `/warehouses/clients`,
};

const productUpdates = {
  getAll: () => "/all-client-product-updates/clients/all-product-updates",
  post: () => `/product-updates`,
  getStats: () => `/product-updates/stats`,
  patch: ({ productUpdateId }) => `/product-updates/${productUpdateId}`,
  patchUserUpdates: ({ productUserUpdateId }) =>
    `/product-user-updates/${productUserUpdateId}`,
};

const invoices = {
  getCourierInvoiceRowErrors: ({ courierInvoiceUploadId }) =>
    `/couriers/invoice-upload-row-errors/${courierInvoiceUploadId}`,
  getCourierInvoicePendingRowErrors: ({ courierInvoiceUploadId }) =>
    `/couriers/invoice-upload-pending-row-errors/${courierInvoiceUploadId}`,
  bulkIgnoreInvoiceUploadRowErrors: () =>
    `/couriers/bulk-ignore-invoice-upload-row-errors`,
  downloadCourierInvoiceRowErrors: ({ courierInvoiceUploadId }) =>
    `/couriers/download-invoice-row-errors/${courierInvoiceUploadId}`,
  putCourierInvoice: ({ courierInvoiceId }) =>
    `/courier/invoices/${courierInvoiceId}`,
  getCourierInvoices: () => `/courier-invoices`,
  postCourierInvoiceConsignment: () => `/courier-invoice`,
  getAllCharges: ({ consignmentId }) =>
    `/consignments/all-charges/${consignmentId}`,
  get: ({ clientId }) => `/clients/${clientId}/parcels-invoices`,
  getAll: ({ before_id, after_id, page, limit = 50 }) => {
    return `/clients-invoices?limit=${limit}`;
  },
  patchInvoice: ({ clientId, invoiceId }) =>
    `/clients/${clientId}/invoices/${invoiceId}`,
  postParcelsInvoice: () => `/customer/process-invoice-data`,
};

export const courierInvoices = {
  getCourierInvoiceById: ({ courierInvoiceId }) =>
    `/courier/invoices/${courierInvoiceId}`,
  getCourierInvoiceConsignments: ({ courierInvoiceId }) =>
    `/courier/invoices/${courierInvoiceId}/consignments`,
  postCourierInvoiceReconcileConsignments: ({ courierInvoiceId }) =>
    `/courier/invoices/${courierInvoiceId}/reconcile-consignments`,
  postCourierInvoiceReconcileSurcharges: ({ courierInvoiceId, action }) =>
    `/courier/invoices/${courierInvoiceId}/reconcile-surcharges/${action}`,
  getCourierInvoiceSurcharges: ({ courierInvoiceId }) =>
    `/courier/invoices/${courierInvoiceId}/surcharges`,
};

const notifications = {
  get: () => `/notifications`,
};

const zones = {
  getAll: () => `/zones`,
  getByCourierId: ({ courierId }) => `/carriers/${courierId}/zones`,
  postDeliveryZones: ({ courierId }) => `/carriers/${courierId}/zones`,
  getZonesWithPostCodes: ({ courierId }) =>
    `/carriers/${courierId}/zones-postcodes`,
  putZonesWithPostCodes: ({ courierId }) =>
    `/carriers/${courierId}/zones-postcodes`,
  deleteZonesById: ({ courierId, zoneId }) =>
    `/carriers/${courierId}/zones/${zoneId}`,
};

const courierZones = {
  get: ({ courierId }) => `/carriers/${courierId}/courier-zones`,
  delete: ({ courierId, zoneId }) =>
    `/carriers/${courierId}/courier-zones/${zoneId}`,
  post: ({ courierId, zoneId }) =>
    `/carriers/${courierId}/courier-zones/${zoneId}`,
};

const stock = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/stock`,
  getStockCSV: ({ warehouseId }) => `/warehouses/${warehouseId}/stock-csv`,
};

const countries = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/countries`,
};

const stuckReasons = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/stuck-reasons`,
};

const collections = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/collections`,
  putCollectionsClose: ({ warehouseId, collectionId }) =>
    `/warehouses/${warehouseId}/collections/${collectionId}/close`,
  postCollectionsSchedule: ({ clientId }) =>
    `/clients/${clientId}/collection-schedules`,
  putCollectionSchedule: ({ clientId, requestId }) =>
    `/clients/${clientId}/collection-schedules/${requestId}`,
  getCollectionSchedules: ({ clientId }) =>
    `/clients/${clientId}/collection-schedules`,
};

const deliveries = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/deliveries`,
  getById: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}`,
  getNotes: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/notes`,
  getImages: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/images`,
  deleteImages: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/images`,
  putDeliveryLines: ({ warehouseId, deliveryId, deliveryLineId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/delivery-lines/${deliveryLineId}`,
  putDelivery: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}`,
  deleteDeliveryLineCheckIn: ({ warehouseId, deliveryId, deliveryLineId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/delivery-lines/${deliveryLineId}/check-in`,
  postNotes: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/notes`,
  postImages: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/images`,
  putImages: ({ warehouseId, deliveryId }) =>
    `/warehouses/${warehouseId}/deliveries/${deliveryId}/images`,
};

const locations = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/locations`,
  getById: ({ warehouseId, locationId }) =>
    `/warehouses/${warehouseId}/locations/${locationId}`,
  putById: ({ warehouseId, locationId }) =>
    `/warehouses/${warehouseId}/locations/${locationId}`,
  post: ({ warehouseId }) => `/warehouses/${warehouseId}/locations`,
  putClear: ({ warehouseId, stockLocationId }) =>
    `/warehouses/${warehouseId}/locations/${stockLocationId}/clear`,
};

const consignments = {
  get: ({ warehouseId, limit }) => {
    let endpoint = `/warehouses/${warehouseId}/consignments`;
    return Number.isInteger(limit) ? `${endpoint}?limit=${limit}` : endpoint;
  },
  getById: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}`,
  getNotes: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/notes`,
  postNotes: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/notes`,
  post: ({ warehouseId }) => `/warehouses/${warehouseId}/consignments`,
  putConsignmentStuck: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/stuck`,
  putConsignmentUnstuck: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/unstuck`,
  putDeliveryAddress: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/address`,
  putDeliveryTelephoneNo: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/phone`,
  getNext: ({ warehouseId }) =>
    `/warehouses/${warehouseId}/consignments/pack?limit=1`,
  getPostageOptions: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/postage-services`,
  putConsignmentPacked: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/packed`,
  putConsignmentUnpacked: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/unpacked`,
  putConsignmentInProcess: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/in-process`,
  putConsignmentPrime: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/prime`,
  putConsignmentDispatched: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/dispatched`,
  getPostageLabels: ({ warehouseId, consignmentId }) =>
    `/warehouses/${warehouseId}/consignments/${consignmentId}/postage-labels`,
  getPackSummary: ({ warehouseId }) =>
    `/warehouses/${warehouseId}/packing-summary`,
  putParcelsConsignments: () => `/warehouses/consignments`,
  getConsignmentByTrackingId: ({ warehouseId }) =>
    `/warehouses/${warehouseId}/tracking/consignments`,
  postOrderComments: ({ warehouseId }) =>
    `/warehouses/${warehouseId}/order-comments`,
  getOrderComments: ({ warehouseId, orderId }) =>
    `/warehouses/${warehouseId}/order-comments/${orderId}`,
  getMultiPackageConsignmentLabelTrackingNumbers: ({
    consignmentId,
    clientId,
  }) =>
    `/clients/${clientId}/multi-package-consignment-label-tracking-numbers/${consignmentId}`,
};

const clients = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/clients`,
  getAllClients: () => `/clients`, // confusingly, this gets all by warehouse
  getUserClients: () => `/warehouses/user-clients`,
  getClientsAll: () => `/clients/all`, // this actually returns all
  post: () => `/warehouses/client`,
  postUser: () => `/clients/create`,
  postClientRates: () => `/warehouses/client-rate`,
  updateClientRates: ({ clientRateId }) =>
    `/warehouses/client-rate/${clientRateId}`,
  deleteClientRate: ({ clientRateId, clientId }) =>
    `/warehouses/${clientId}/client-rate/${clientRateId}`,
  getClienRateServices: ({ clientId }) => `/clients/rate-services/${clientId}`,
  getParcelsClients: ({ limit }) =>
    `/warehouses/parcels-clients?limit=${limit}`,
  getParcelsClientById: ({ clientId }) => `/parcels-clients/${clientId}`,
  getClientRates: ({ clientId }) => `/warehouses/client-rate/${clientId}`,
  getClientServiceRates: ({ clientId, courierServiceId }) =>
    `/warehouses/rate-services/${clientId}/${courierServiceId}`,
  getClientUsers: ({ clientId }) => `/clients/${clientId}/users`,
  updateClientUser: ({ clientId }) => `/clients/${clientId}/users`,
  updateClient: ({ clientId }) => `/warehouses/client/${clientId}`,
  updateClientStatus: ({ clientId }) => `/warehouses/client/${clientId}/status`,
  deleteUserClient: ({ userClientId, clientId }) =>
    `/clients/${clientId}/users/${userClientId}`,
  getCouriers: ({ clientId }) => `/clients/${clientId}/couriers`,
  getCouriersByWarehouse: ({ clientId }) =>
    `/clients/${clientId}/couriers-warehouse`,
  postClientRate: () => `/clients/add-client-rate`,
  getAuditTrail: ({
    clientId,
    courierProductId,
    courierServiceId,
    courierPricingMethodId,
  }) =>
    `/rates/audit-trail/${clientId}/${courierProductId}/${courierServiceId}/${courierPricingMethodId}`,
  postClientRateCSV: () => `/clients/add-client-rate-csv`,
  postClientDocument: ({ clientId }) => `/clients/${clientId}/client-documents`,
  patchClientDocument: ({ clientId, clientDocId }) =>
    `/clients/${clientId}/client-documents/${clientDocId}`,
  deleteClientDocument: ({ clientId, clientDocId }) =>
    `/clients/${clientId}/client-documents/${clientDocId}`,
  getAllClientTypes: () => `/warehouses/clients/types`,
  postClientCredentials: ({ clientId }) => `/clients/${clientId}/credentials`,
  getClientCourierServices: ({ clientId }) =>
    `/warehouses/clients/${clientId}/courier-services`,
  postM2MUser: () => `/machine-to-machine-account/add-user`,
};

const clientsParcels = {
  post: ({ clientId }) => `/clients/${clientId}/parcels`,
  get: ({ clientId }) => `/clients/${clientId}/parcels`,
  delete: ({ clientId, clientParcelId }) =>
    `/clients/${clientId}/parcels/${clientParcelId}`,
};

const staff = {
  post: () => `/staff`,
  get: ({ userType }) => `/staff?userType=${userType}`,
  getRoles: () => `/user-role-types`,
  put: ({ userId }) => `/staff/${userId}`,
  getUserAccountTypes: () => `/staff/account-types`,
};

const surcharges = {
  getPostageCostSurchargesById: ({ costSurchargeId }) =>
    `/surcharges/postage-cost-surcharges/${costSurchargeId}`,
  getCostSurchargeZonesById: ({ costSurchargeId }) =>
    `/surcharges/cost-surcharge-zones/${costSurchargeId}`,
  getApplicableZones: ({ costSurchargeId, courierId }) =>
    `/surcharges/${costSurchargeId}/zones/${courierId}`,
  getApplicablePostageServices: ({ costSurchargeId, courierId }) =>
    `/surcharges/${costSurchargeId}/postage-services/${courierId}`,
  putSurchargeCostHistoryById: ({ costSurchargeId }) =>
    `/surcharges/surcharge-cost-history/${costSurchargeId}`,
  getSurchargeCostHistoryById: ({ costSurchargeId }) =>
    `/surcharges/surcharge-cost-history/${costSurchargeId}`,
  deleteCostSurchargeZone: ({ costSurchargeId, costSurchargeZoneId }) =>
    `/surcharges/${costSurchargeId}/cost-surcharge-zones/${costSurchargeZoneId}`,
  deletePostageCostSurcharge: ({ costSurchargeId, postageCostSurchargeId }) =>
    `/surcharges/${costSurchargeId}/postage-cost-surcharges/${postageCostSurchargeId}`,
  postCostSurchargeZone: () => `/surcharges/cost-surcharge-zones`,
  postPostageCostSurcharges: () => `/surcharges/postage-cost-surcharge`,

  getManualCostSurchargesByConsignmentId: ({ consignmentId }) =>
    `/warehouses/cost-surcharge/${consignmentId}`,
  getSurchargeTypes: () => `/surcharge/surcharge-types`,
  postSurchargeTypes: () => `/surcharge/surcharge-type`,
  deleteSurchargeTypes: ({ surchargeTypeId }) =>
    `/surcharge/${surchargeTypeId}/surcharge-types`,
  putSurchargeTypes: ({ surchargeTypeId }) =>
    `/surcharge/${surchargeTypeId}/surcharge-types`,
  postConsignmentSurcharge: () => `/surcharge/consignment-surcharge`,
  getSurchargeTypesByCourierId: ({ courierId }) =>
    `/surcharge/surcharge-types/${courierId}`,
  getSurchargesByCourierId: ({ courierId }) =>
    `/surcharges/courier-surcharges/${courierId}`,
  getAllSurcharges: () => `/surcharges/cost-surcharges`,
  postCostSurchargeHistory: ({ costSurchargeId }) =>
    `/surcharges/cost-surcharge-history/${costSurchargeId}`,
};

const costSurcharges = {
  get: () => `/warehouses/cost-surcharge`,
  post: () => `/surcharge/cost-surcharge`,
  postZones: () => `/surcharges/cost-surcharge-zones`,
};

const clientSurcharges = {
  post: () => `/surcharge/client-surcharge`,
  postBulk: () => `/surcharge/client-surcharges`,
  get: ({ clientId, surchargeCostHistoryId }) =>
    `/surcharges/${clientId}/client-surcharges/${surchargeCostHistoryId ?? ""}`,
  put: ({ clientSurchargeId }) =>
    `/surcharge/client-surcharge/${clientSurchargeId}`,
  delete: ({ clientSurchargeId, clientId }) =>
    `/surcharge/${clientId}/client-surcharge/${clientSurchargeId}`,
};

const couriers = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/couriers`,
  post: () => `/warehouses/couriers`,
  getAll: () => `/warehouses/couriers`,
  getAllTypes: () => `/warehouses/couriers/types`,
  getWarehouseCouriers: ({ courierId }) =>
    `/warehouses/warehouse-couriers/${courierId}`,
  patch: ({ courierId }) => `/warehouses/couriers/${courierId}`,
  delete: ({ courierId }) => `/warehouses/couriers/${courierId}`,
  postProduct: () => `/warehouses/courier-products`,
  getProduct: ({ courierId }) => `/warehouses/couriers/${courierId}/products`,
  putProduct: ({ courierProductId }) =>
    `/warehouses/couriers/products/${courierProductId}`,
  deleteProduct: ({ courierId, courierProductId }) =>
    `/warehouses/couriers/${courierId}/products/${courierProductId}`,
  postCourierCredentials: ({ courierId }) =>
    `/carriers/${courierId}/credentials`,
  restore: ({ courierId, warehouseId }) =>
    `/warehouses/${warehouseId}/couriers/${courierId}/restore`,
};

const carriers = {
  getAll: () => "/carriers/carrier-codes",
  getServices: () => "/courier-services-paginated",
};

const accountTypes = {
  get: () => `/accountTypes`,
};

export const audits = {
  getAuditLogs: ({ entityType, entityId }) =>
    `/audits/logs/${entityType}/${entityId}`,
};

const glCodes = {
  get: () => `/gl-codes`,
};

const branches = {
  post: () => `/branches`,
  get: () => `/branches`,
  getAllBranchTypes: () => `/branches/types`,
  patch: ({ branchId }) => `/branches/${branchId}`,
  delete: ({ branchId }) => `/branches/${branchId}`,
  getUserAssignedBranches: () => `/branches/user-branches`,
};

const postageServices = {
  postPostageService: () => `/warehouses/postage-services`,
  getAllPostageServices: () => `/warehouses/couriers/postage-services`,
  postPostageServiceVariants: () => `/warehouses/postage-service-variants`,
  postPostageCostHistory: () => `/warehouses/postage-history`,
  getPostageServicesByCourierId: ({ courierId }) =>
    `/warehouses/postage-services/${courierId}`,
  putPostageServiceByCourierId: ({ courierId }) =>
    `/warehouses/postage-services/${courierId}`,
  getAvailablePostageServiceByCourierId: ({ courierId }) =>
    `/warehouses/postage-services/${courierId}/available`,
  deletePostageServiceByCourierId: ({ courierId, postageServiceId }) =>
    `/warehouses/postage-services/${postageServiceId}/${courierId}`,
  getPostageBookingMethods: () => `/warehouses/postage-booking-methods`,
  getPostageServiceRates: (courierId, postageServiceId, clientId) =>
    `/rates/postage-service-rates/${courierId}/${postageServiceId}/${clientId}`,
  getCostPerAdditionalWeightMultipliers: () =>
    `/cost-per-additional-weight-multipliers`,
  getLatestPostageCostForVariantId: ({ postageServiceVariantId }) =>
    `/rates/postage-history/${postageServiceVariantId}`,
};

const postalAddresses = {
  get: ({ term }) => `/postal-addresses/${term}`,
  getAddressInfo: ({ addressId }) => `/postal-addresses/info/${addressId}`,
};

const returns = {
  post: ({ warehouseId }) => `/warehouses/${warehouseId}/return`,
  cancel: ({ warehouseId }) => `/warehouses/${warehouseId}/return/cancel`,
};

const transfers = {
  post: ({ warehouseId }) => `/warehouses/${warehouseId}/transfers`,
};

const skus = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/all-skus`,
  getPaginated: ({ warehouseId }) => `/warehouses/${warehouseId}/paginate-skus`,
  getById: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}`,
  getSkuLocationHistory: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/location-history`,
  getSkuStock: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/stock`,
  getSkuStockHistory: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/stock-history`,
  getCoOrderedSkus: ({ warehouseId, skuId, limit }) => {
    let endpoint = `/warehouses/${warehouseId}/skus/${skuId}/co-ordered-skus`;
    return Number.isInteger(limit) ? `${endpoint}?limit=${limit}` : endpoint;
  },
  postLocation: ({ warehouseId, stockLocationId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/locations/${stockLocationId}`,
  putDimensions: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/dimensions`,
  putStockTake: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/stock-take`,
  putBarcodes: ({ warehouseId, skuId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/barcodes`,
  putSkuPhotos: ({ skuId, warehouseId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/photos`,
  deleteSkuPhotos: ({ skuId, warehouseId }) =>
    `/warehouses/${warehouseId}/skus/${skuId}/photos`,
};

const salesChannels = {
  get: ({ warehouseId }) => `/warehouses/${warehouseId}/sales-channels`,
};

const users = {
  getAllUsers: () => `/users`,
  getUserById: ({ userId }) => `/users/${userId}`,
  putUserById: ({ userId }) => `/users/${userId}`,
  postUser: () => `/users`,
  getUserAssignedBranchesWarehouses: () => `users/assigned-branches-warehouses`,
  getAllM2MUsers: () =>
    `/machine-to-machine-account/list-machine-to-machine-pools`,
  getClientApiDetails: ({ clientId }) =>
    `/warehouses/clients/${clientId}/api-details`,
  getM2MUserById: ({ id }) =>
    `/machine-to-machine-account/list-machine-to-machine-pool/${id}`,
  postM2MUser: () => `/machine-to-machine-account/add-user`,
  deleteM2MUser: () => `/machine-to-machine-account/delete-user`,
};

const reports = {
  getLabelsBookedReport: ({ clientId }) =>
    `/warehouses/${clientId}/reports/shipment-report`,
};

const creditNotes = {
  post: () => `/clients/credit-notes`,
};

const depots = {
  get: () => `/depots`,
};

const storage = {
  post: ({ clientId }) => `/clients/${clientId}/storage`,
  get: ({ clientId }) => `/clients/${clientId}/storage`,
  delete: ({ clientId, storageChargeId }) =>
    `/clients/${clientId}/storage/${storageChargeId}`,
};

const misc = {
  get: ({ clientId }) => `/clients/${clientId}/misc-charges`,
  post: ({ clientId }) => `/clients/${clientId}/misc-charges`,
  delete: ({ clientId, miscRateHistoryId }) =>
    `/clients/${clientId}/misc-charges/${miscRateHistoryId}`,
  getMiscServices: () => `/misc-services`,
};

const paymentTypes = {
  getAll: () => `/payment-types`,
};

const paymentTerms = {
  getAll: () => `/payment-terms`,
};

const roles = {
  getAllRoles: () => `/roles`,
  getRoleById: ({ roleId }) => `/roles/${roleId}`,
  putRoleById: ({ roleId }) => `/roles/${roleId}`,
  postRole: () => `/roles`,
};

const permissions = {
  getAllPermissions: () => `/permissions`,
  getPermissionById: ({ permissionId }) => `/permissions/${permissionId}`,
  putPermissionById: ({ permissionId }) => `/permissions/${permissionId}`,
  postPermission: () => `/permissions`,
};

const taxCodes = {
  getAll: () => `/clients/tax-codes`,
};

const currencies = {
  getAll: () => `/currencies`,
};

const unitOfMeasurements = {
  getAll: () => `/unit-of-measurements`,
};

const configs = {
  getFeatureToggles: ({ warehouseId }) =>
    `/warehouses/${warehouseId}/config/feature-toggles`,
  patchFeatureToggles: ({ warehouseId, id }) =>
    `/warehouses/${warehouseId}/config/feature-toggles/${id}`,
};

const courierDocuments = {
  get: () => "/courier-documents",
  post: () => "/courier-documents",
  patch: ({ courierDocId }) => `/courier-documents/${courierDocId}`,
};

const packageTypes = {
  getByPostageBookingMethodId: ({ postageBookingMethodId }) =>
    `/packaging-types/postage-booking-method/${postageBookingMethodId}`,
};

const carrierServices = {
  getCarrierServicesByPostageBookingMethodId: ({ postageBookingMethodId }) =>
    `/courier-services/${postageBookingMethodId}`,
};
const globalSearch = {
  post: ({ params, activeWarehouseId }) =>
    `/warehouses/${activeWarehouseId}/globalSearch${params}`,
};

const cutsomsDuty = {
  getCustomsDuty: () => "/clients/customs-duty",
};

const powerBi = {
  getPowerBiReports: () => "/warehouses/powerBi/reports",
  postPowerBiReportGroup: () => "/warehouses/powerBi/reports/groups",
  patchPowerBiReportGroup: ({ reportGroupId }) =>
    `/warehouses/powerBi/reports/groups/${reportGroupId}`,
  deletePowerBiReportGroup: ({ reportGroupId }) =>
    `/warehouses/powerBi/reports/groups/${reportGroupId}`,
  getAllPowerBiReports: () => "/warehouses/powerBi/reports/all",
  getPowerBiUsersReports: () => "/warehouses/powerBi/users/reports",
  getPowerBiReportGroups: () => "/warehouses/powerBi/reports/groups",
  getPowerBiReport: ({ reportKey }) =>
    `/warehouses/powerBi/reports/${reportKey}`,
};

const ebayAnalytics = {
  getAPIContextsData: () => `/ebay-analytics/get-contexts`,
  getAPINamesData: () => `/ebay-analytics/get-api-names`,
  getAPIResourcesData: () => `/ebay-analytics/get-resource-names`,
  postAPIAnalyticsData: () =>
    `/ebay-analytics/post-analytics-by-resource-name-id`,
  postAPIAnalyticsTop10Data: () => `/ebay-analytics/post-analytics-top-10`,
};

const crudLogs = {
  postCrudLogs: () => `/crudLogs`,
};

const mail = {
  get: () => `/mail`,
};

const order = {
  getById: ({ clientId, orderId }) => `/clients/${clientId}/orders/${orderId}`,
  getNotes: ({ clientId, orderId }) =>
    `/clients/${clientId}/orders/${orderId}/notes`,
  postNotes: ({ clientId, orderId }) =>
    `/clients/${clientId}/orders/${orderId}/notes`,
};

const postageBookingErrorMessages = {
  getAll: () => `/postage-booking-error-messages`,
  getByHash: ({ hash }) => `/postage-booking-error-messages/${hash}`,
  patch: ({ hash }) => `/postage-booking-error-messages/${hash}`,
  getTypes: () => `/postage-booking-error-message-types`,
  getLogs: ({ hash }) => `/postage-booking-error-messages/${hash}/logs`,
};

const companies = {
  get: () => `/companies`,
};

export {
  courierDocuments,
  packageTypes,
  warehouse,
  stock,
  countries,
  collections,
  stuckReasons,
  consignments,
  clients,
  couriers,
  carriers,
  returns,
  skus,
  salesChannels,
  deliveries,
  locations,
  transfers,
  costSurcharges,
  clientSurcharges,
  zones,
  postageServices,
  users,
  postalAddresses,
  staff,
  reports,
  accountTypes,
  branches,
  invoices,
  creditNotes,
  surcharges,
  depots,
  productUpdates,
  clientsParcels,
  storage,
  misc,
  paymentTypes,
  paymentTerms,
  roles,
  permissions,
  taxCodes,
  unitOfMeasurements,
  configs,
  notifications,
  currencies,
  courierZones,
  carrierServices,
  cutsomsDuty,
  glCodes,
  powerBi,
  ebayAnalytics,
  crudLogs,
  globalSearch,
  mail,
  order,
  postageBookingErrorMessages,
  companies,
};
